import * as types from '../actions/types';

const initialState = {
    searchrewardredeemdata: [],
    success: false
}

export default function RewardredeemSearchReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.SEARCH_DATA_REWARD_REDEEM:
            return {

                searchfaqdata: action.payload,
                success: true
            }
        default:
            return state
    }
}
